import { Service } from '../types/rest/assetCatalogTypes';

export const dataModelIdPrefix = 'MS-service';
export const dataModelNamePrefix = 'MS';

//Prefix for entity name
export const globalEntityNamePrefix = 'global-entity';

//Name of the dependency (used for link creation)
export const globalEntityDependencyName = 'global-entity-svc';

export const validParameterRegex = /^(?![0-9])[a-zA-Z0-9$_]+$/;

export const generateDataModelId = (serviceId: number) => {
  return `${dataModelIdPrefix}-${serviceId}`;
};

export const generateDataModelName = (service: Service) => {
  return `${dataModelNamePrefix}-${service.name}-${service.id}`;
};

export const generateGlobalEntityName = (serviceId: number) => {
  return `${globalEntityNamePrefix}-${serviceId}`;
};
